
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(-1); // start with all closed

  const faqs = [
    {
      question: 'When should I start planning my tax strategy?',
      answer:
        "The best time to start tax planning is at the beginning of the fiscal year, but it's never too late to begin. Proactive tax planning throughout the year allows us to identify opportunities for deductions, credits, and strategic decisions that can significantly reduce your tax liability. We recommend quarterly reviews to stay on track and adjust strategies as your financial situation evolves."
    },
    {
      question: 'What documents do I need to prepare my tax return?',
      answer:
        "Required documents typically include W-2s, 1099s, receipts for deductible expenses, mortgage interest statements, investment income statements, and records of charitable contributions. For business owners, we'll also need profit and loss statements, balance sheets, and documentation of business expenses. We provide a comprehensive checklist tailored to your specific situation during our initial consultation."
    },
    {
      question: 'How can I reduce my tax liability legally?',
      answer:
        'There are numerous legal strategies to minimize taxes, including maximizing retirement contributions, timing income and deductions strategically, taking advantage of available tax credits, implementing proper business structure, and utilizing tax-advantaged investment accounts. Our team analyzes your unique situation to identify the most effective strategies for your circumstances.'
    },
    {
      question: 'What happens if I get audited by the IRS?',
      answer:
        "If you receive an audit notice, don't panic. Our IRS representation services include full support throughout the audit process. We'll review the notice, gather necessary documentation, communicate with the IRS on your behalf, and represent your interests during all proceedings. Our experience with IRS procedures helps ensure the best possible outcome."
    },
    {
      question: 'Do you offer services for both individuals and businesses?',
      answer:
        'Yes, we provide comprehensive tax services for individuals, small businesses, corporations, partnerships, and LLCs. Our team has expertise across all entity types and can handle everything from simple individual returns to complex multi-state business filings. We also offer specialized services for estate planning and trust taxation.'
    },
    {
      question: 'How far in advance should I schedule my tax preparation?',
      answer:
        'We recommend scheduling your tax preparation appointment at least 4-6 weeks before the filing deadline to ensure adequate time for thorough preparation and review. However, we accept clients year‑round and can accommodate urgent situations. Early filers often benefit from faster refunds and reduced stress during tax season.'
    },
    {
      question: 'What makes your tax strategy services different?',
      answer:
        'Our approach goes beyond basic tax preparation. We focus on proactive, year‑round tax planning that aligns with your long‑term financial goals. Our team stays current with constantly changing tax laws, identifies opportunities others might miss, and provides personalized strategies rather than one‑size‑fits‑all solutions. We build lasting relationships with our clients, serving as trusted advisors for all tax‑related matters.'
    },
    {
      question: "Can you help with previous years' unfiled tax returns?",
      answer:
        'Absolutely. We specialize in helping clients who have fallen behind on their tax filings. We can prepare multiple years of returns, work with the IRS to establish payment plans if needed, and help you get back into compliance. The sooner you address unfiled returns, the better, as penalties and interest continue to accrue over time.'
    }
  ];

  return (
    <section id="faq" className="py-24 px-8 bg-[#f8f9fb]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-12">
          <div className="md:col-span-2 md:sticky md:top-24 self-start">
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-px bg-[#00e5c7]"></div>
              <span className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold">
                Common Questions
              </span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-[#0a1628] mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Everything You Need to Know
            </h2>
            <p className="text-sm text-[#5a6a7e] leading-relaxed mb-8">
              Find answers to frequently asked questions about our tax services,
              processes, and how we can help you achieve your financial goals.
            </p>
            <div className="bg-[#0a1628] rounded-lg p-6">
              <p className="text-sm text-white/70 mb-3">Still have questions?</p>
              <a
                href="#contact"
                className="text-[#00e5c7] hover:text-[#00ccb0] font-semibold text-sm cursor-pointer inline-flex items-center"
              >
                Contact us directly
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`rounded-lg overflow-hidden transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-white shadow-lg border border-[#00e5c7]/20'
                      : 'bg-white border border-gray-200/80 hover:border-[#00e5c7]/20'
                  }`}
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50/50 transition-colors cursor-pointer"
                    aria-expanded={openIndex === index}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <span className="text-base font-semibold pr-4 text-[#0a1628]">
                      {faq.question}
                    </span>
                    <div
                      className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 transition-all ${
                        openIndex === index ? 'bg-[#00e5c7]' : 'bg-[#0a1628]/5'
                      }`}
                    >
                      <i
                        className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-[#0a1628]`}
                      ></i>
                    </div>
                  </button>
                  {openIndex === index && (
                    <div id={`faq-answer-${index}`} className="px-6 pb-6">
                      <p className="text-sm text-[#5a6a7e] leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
